import React from 'react';
import { Label } from 'react-bootstrap';
import * as App from 'modules/app/App';

class DateColor extends React.Component {
	shouldComponentUpdate(nextProps) {
		return (nextProps.value !== this.props.value
				|| nextProps.dependentValues !== this.props.dependentValues);
	}

	render() {
		var color = "#000000";
		var bg = this.props.backgroundColor;
		var label = this.props.emptyLabel;

		if (this.props.value === 'SVCMEM')
		{
			bg = "#cc0000"; // Red
			color = "#FFFFFF";
			label = "SVCMEM";
		}
		else if (this.props.value === 'VETERAN')
		{
			bg = "#43d162"; // Green
			label = "VETERAN";
		}
		else if (this.props.value === 'CONFLICT')
		{
			bg = "yellow"; // yellow
			label = "CONFLICT";
		}
		else if (this.props.value === 'PENDING_ZERO')
		{
			bg = "#d2d6de"; // grey
			label = "PENDING";
		}
		else if (this.props.value === 'PENDING')
		{
			bg = "orange"; // orange
			label = "PENDING";
		}
		
		// If Veteran Owner detected with same OwnerSSN but different first/last name
		if (this.props.value && this.props.dependentValues.dD214Warning)
			bg = "#66ccff";

		let style = {
			backgroundColor: bg,
			color: color,
			display: "block",
			position: "relative",
			width: "100%",
			height: "34px",
			paddingTop: "10px",
			margin: "0",
			padding: "0",
			borderColor: "#d2d6de",
    		borderRadius: "0",
			borderStyle: this.props.borderStyle,
    		borderWidth: "1px"
		};

		var url = "";

		if (this.props.value && this.props.dependentValues) {
			url = `/admin/veteranDD214/${this.props.dependentValues.certificationKey}`;
		}

		return (
			<React.Fragment>
				{App.hasPrivilege("AdminDD214Setup") && url !== "" ?
					<a href={url}>
						<Label style={style}>
							<span style={{ display: "block", paddingTop: "12px" }}>
								{label}
							</span>
						</Label>
					</a>
				:
					<Label style={style}>
						<span style={{ display: "block", paddingTop: "12px" }}>
							{label}
						</span>
					</Label>
				}
			</React.Fragment>
		)
	}
}

export default DateColor;

DateColor.defaultProps = {
	backgroundColor: "transparent",
	emptyLabel: "EMPTY",
	borderStyle: ""
};


// WEBPACK FOOTER //
// ./src/areas/admin/shared/DateColor.js